import React, {Component} from 'react';
import '../../styles/Home.css'
import AktualnosciComponent from "./aktualnosciComponents/AktualnosciComponent";
import Footer from "../../shared/Footer";
import AplikacjaMobilna from "./AplikacjaMobilna";
import AktualnosciPost from "./aktualnosciComponents/AktualnosciPost";
import Newsletter from "./Newsletter";

export default class Aktualnosci extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Bądź na bieżąco!</b></h2>
                    <h4>Wciąż dodajemy nowe kursy by sprostać oczekiwaniom klientów.</h4>
                </div>
            </div>

            <div className="panelPaddingMobilka"
                 style={{background: '#f9f9f9', paddingTop: '25px', paddingBottom: '25px'}}>
                <div className="container" style={{background: '#fff', padding: 0}}>
                    {this.props.match.params.id !== null && this.props.match.params.id !== undefined ?
                        <AktualnosciPost id={this.props.match.params.id} data={this.props.match.params.data}/> :
                        <AktualnosciComponent/>}
                </div>
            </div>
            {/*<AplikacjaMobilna/>*/}
            <Newsletter/>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Aktualnosci.js